// Diff theo dòng của một cảnh (trước → sau) trong thẻ xem thử của khung Trợ lý AI.
import React from 'react';
import { lineDiff } from '../../episodeFixUtils';

const BeatDiff: React.FC<{ before: string[]; after: string[] }> = ({ before, after }) => (
  <div style={{ fontFamily: 'monospace', fontSize: 12 }}>
    {lineDiff(before, after).map((l, i) => (
      <div
        key={i}
        style={{
          padding: '1px 6px', whiteSpace: 'pre-wrap',
          background: l.op === 'add' ? 'var(--wb-add-bg)' : l.op === 'del' ? 'var(--wb-del-bg)' : 'transparent',
          color: l.op === 'del' ? 'var(--wb-bad)' : undefined, textDecoration: l.op === 'del' ? 'line-through' : undefined,
        }}
      >
        {l.op === 'add' ? '+ ' : l.op === 'del' ? '− ' : '  '}{l.text}
      </div>
    ))}
  </div>
);

export default BeatDiff;
